import { z } from 'zod'

export const templatesValidation = z.object({
  name: z.string().min(1, { message: 'Template Name must not be blank' }).max(30, { message: 'Cert Number must not be longer than 30 characters' }),
  featureSettings: z.array(
    z.object({
      featureId: z.string(),
      featureName: z.string(),
      featureValue: z.string().min(1, { message: 'Value must not be blank' }),
      privileges: z.array(z.string()).optional(),
    }),
  ),
  divisionId: z.string().min(1, { message: 'Must select a division' }),
  productId: z.string().min(1, { message: 'Must select a product' }),
})

export type TemplateValidation = z.infer<typeof templatesValidation>
